import React from 'react';
import Link from '../../link';

interface Props {
  items: NavigationItem[];
}

interface NavigationItem {
  text: string;
  href: string;
}

const WholesalePartsHubSectionNavigation: React.FC<Props> = ({ items }) => (
  <nav>
    <ul>
      {items.map((item, index) => (
        <li key={index}>
          <Link href={item.href}>
            <a>{item.text}</a>
          </Link>
        </li>
      ))}
    </ul>
    {/* language=CSS */}
    <style jsx>{`
      nav {
        margin-top: 1rem;
        margin-bottom: 1rem;
        text-align: center;
      }

      ul {
        list-style: none;
        margin: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-evenly;
        gap: 1rem;
      }

      ul li {
        display: inline-block;
      }

      ul li a {
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
        font-weight: 400;
        color: #333;
        text-decoration: none;
      }

      ul li a:hover {
        color: #707070;
      }
    `}</style>
  </nav>
);

export default WholesalePartsHubSectionNavigation;
